// extracted by mini-css-extract-plugin
module.exports = {"container":"retailer-terms_container__mIj5C","fade-in":"retailer-terms_fade-in__GbbLV"};